import { render, staticRenderFns } from "./CreateRecipeCost.vue?vue&type=template&id=27bceb66&scoped=true"
import script from "./CreateRecipeCost.vue?vue&type=script&lang=ts"
export * from "./CreateRecipeCost.vue?vue&type=script&lang=ts"
import style0 from "./CreateRecipeCost.vue?vue&type=style&index=0&id=27bceb66&prod&scoped=true&lang=css"
import style1 from "./CreateRecipeCost.vue?vue&type=style&index=1&id=27bceb66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bceb66",
  null
  
)

export default component.exports